module.exports = __webpack_public_path__ + "media/images/iconSquadBet__sub-f7300792bd8055831bb448a593e4179d.png";